// extracted by mini-css-extract-plugin
export var standaloneTable = "_1g-0";
export var standaloneTableWithBodyFill = "_1g-1";
export var withExtraHeader = "_1g-2";